<svelte:options accessors/>
<script>
    import NauiExplorer from "../../naui/pages/NauiExplorer.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";

    export let data;
    export let columns;
    export let pages;
    export let filters;
    export let count;
    let explorerCmpt;

    const dispatcher = createEventDispatcher()

    function descargarReporte() {
        dispatcher('xlsx');
    }

    export function getParams() {
        if (explorerCmpt) {
            return explorerCmpt.getParams();
        }
    }
</script>

<div>
    <NauiExplorer {data}
                  {pages}
                  {count}
                  {columns}
                  {filters}
                  hideSearch={true}
                  paginate={true}
                  on:filter
                  on:next
                  bind:this={explorerCmpt}>
        <div slot="actions">
            <div class="flex">
                <NauiButton on:click={descargarReporte} caption="DESCARGAR REPORTE" mode="stroked"/>
            </div>
        </div>
    </NauiExplorer>
</div>
